import { render } from "./FootterOrson.vue?vue&type=template&id=5611345e&scoped=true"
import script from "./FootterOrson.vue?vue&type=script&lang=js"
export * from "./FootterOrson.vue?vue&type=script&lang=js"

import "./FootterOrson.vue?vue&type=style&index=0&id=5611345e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5611345e"]])

export default __exports__